import { getPropsForOverview } from "shared/staticHelpers";
import { NL, PERSON_TYPE } from "shared/constants";
import { PersonOverviewPage } from "containers/PersonOverviewPage";

export async function getStaticProps({ locale }) {
  if (locale !== NL) {
    return { notFound: true };
  }

  return await getPropsForOverview({
    locale,
    type: PERSON_TYPE,
    query: " && defined(departments)",
  });
}

const PageToExport = (props) => <PersonOverviewPage {...props} />;

export default PageToExport;
